var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, InsertLinkOutlined } from '@mui/icons-material';
import { LinearProgress, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../../../../assets/customIcons';
import { DynamicFormBuilderContainer } from '../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { MuiStack } from '../../../../../../components';
import StatusColor from '../../../../../../components/atoms/statusColor';
import { LOCAL_STORAGE_KEYS } from '../../../../../../constants';
import { showNewNotification } from '../../../../../../redux/commonSlice';
import { resetState } from '../../../../../../redux/crudSlice';
import { systemColor } from '../../../../../../theme/systemColor';
import { getLocalStorageItem } from '../../../../../../utils/storageHelper';
import { dateFormate, isLoadingState } from '../../../../../../utils/utils';
import { priorityListGet } from '../../../../../stockTransfer/apiCall';
import BToBOutwardPartDetails from '../components/partDetailsBtoBOutward';
import { BToBBranchListAPICall, BToBRequisitionIdAPICall, BToBShippingMethodListAPICall, BToBTransporterNameListAPICall, BToBWarehouseListAPICall, CreateBToBOutwardAPICall, DeleteBToBOutwardAttachmentAPICall, getRequisitionDetailsByIdAPICall, UploadBToBOutwardAttachmentAPICall } from '../services/apiCall';
import { BranchOutwardApiKeys, BranchToBranchOutwardKeys, BToBOutwardStatusEnum } from '../services/entity';
import { ValidationTypes } from '../../../../../../builderPackage/components/regex/validations';
import { faintblue } from '../../../../../../theme/palette';
function CreateBranchToBranchOutward() {
    var _this = this;
    var _crud$BranchToBranchO, _getLocalStorageItem, _getLocalStorageItem2, _crud$profilePersonal4, _crud$profilePersonal5, _crud$profilePersonal6;
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var crud = useSelector(function (state) { return state.crud; });
    var _a = useState(0), grandTotal = _a[0], setGrandTotal = _a[1];
    var _b = useState(0), totalQuantity = _b[0], setTotalQuantity = _b[1];
    var data = (_crud$BranchToBranchO = crud[BranchToBranchOutwardKeys === null || BranchToBranchOutwardKeys === void 0 ? void 0 : BranchToBranchOutwardKeys.BToBOutwardDetails]) === null || _crud$BranchToBranchO === void 0 ? void 0 : _crud$BranchToBranchO.data;
    var dispatch = useDispatch();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var isDisabled = mode == 'edit';
    useEffect(function () {
        getBranchList();
    }, []);
    var getBToBRequistionList = function (params) { return BToBRequisitionIdAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: {
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            Key: BToBOutwardStatusEnum.Completed,
            Type: BranchToBranchOutwardKeys === null || BranchToBranchOutwardKeys === void 0 ? void 0 : BranchToBranchOutwardKeys.BToBRequisitionType
        }
    })); };
    var getBranchList = function () {
        var _crud$profilePersonal;
        return BToBBranchListAPICall({
            request: {
                ParentOrganizationId: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.Branches[0]) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.ParentOrganizationId
            }
        });
    };
    var getTransporterNameList = function (params) {
        var _crud$profilePersonal2;
        return BToBTransporterNameListAPICall(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                OrganizationTypeGroup: 10,
                ParentOrganizationId: crud === null || crud === void 0 || (_crud$profilePersonal2 = crud.profilePersonalDetails) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.data) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.Branches[0]) === null || _crud$profilePersonal2 === void 0 ? void 0 : _crud$profilePersonal2.ParentOrganizationId
            })
        }));
    };
    var getWarehouseList = function (params) {
        var _crud$profilePersonal3;
        return BToBWarehouseListAPICall(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                TenantId: crud === null || crud === void 0 || (_crud$profilePersonal3 = crud.profilePersonalDetails) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.data) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.Branches[0]) === null || _crud$profilePersonal3 === void 0 ? void 0 : _crud$profilePersonal3.OrganizationId
            })
        }));
    };
    var General = [{
            type: FormItemTypes.CardComponent,
            name: 'GeneralTabs',
            label: 'General Tabs',
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'ParentId',
                    label: 'Branch to branch requisition no',
                    placeholder: 'Select branch to branch requisition no',
                    valueExpr: "id",
                    displayExpr: "DocumentCode",
                    getListData: getBToBRequistionList,
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        var _response$data, _response$data2, _response$data3, _response$data4, _response$data5, _response$data6, _response$data7, _response$data8, _response$data9, _response$data10, _response$data11, _response$data12, _response$data13, _response$data14, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getRequisitionDetailsByIdAPICall({
                                        request: {
                                            id: currValue === null || currValue === void 0 ? void 0 : currValue.id
                                        }
                                    })];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, {
                                            SourceWarehouseId: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.SourceWarehouseId,
                                            SourceTenantId: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.SourceTenantId,
                                            DestinationTenantId: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.DestinationTenantId,
                                            PriorityId: response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.PriorityId,
                                            TransporterName: response === null || response === void 0 || (_response$data5 = response.data) === null || _response$data5 === void 0 || (_response$data5 = _response$data5.TransportDetail) === null || _response$data5 === void 0 ? void 0 : _response$data5.TransporterId,
                                            ShippingMethod: response === null || response === void 0 || (_response$data6 = response.data) === null || _response$data6 === void 0 || (_response$data6 = _response$data6.TransportDetail) === null || _response$data6 === void 0 ? void 0 : _response$data6.ShippingMethodId,
                                            ShippingReferenceDocNo: response === null || response === void 0 || (_response$data7 = response.data) === null || _response$data7 === void 0 || (_response$data7 = _response$data7.TransportDetail) === null || _response$data7 === void 0 ? void 0 : _response$data7.ShippingDocumentNo,
                                            ShippingReferenceDocDate: response === null || response === void 0 || (_response$data8 = response.data) === null || _response$data8 === void 0 || (_response$data8 = _response$data8.TransportDetail) === null || _response$data8 === void 0 ? void 0 : _response$data8.ShippingDocumentDate,
                                            NoOfBoxes: response === null || response === void 0 || (_response$data9 = response.data) === null || _response$data9 === void 0 || (_response$data9 = _response$data9.TransportDetail) === null || _response$data9 === void 0 ? void 0 : _response$data9.BoxQuantity,
                                            VehicleNo: response === null || response === void 0 || (_response$data10 = response.data) === null || _response$data10 === void 0 || (_response$data10 = _response$data10.TransportDetail) === null || _response$data10 === void 0 ? void 0 : _response$data10.VehicleNo,
                                            StockTransferRequisitionDetail: response === null || response === void 0 || (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.StockTransferRequisitionDetail,
                                            ExpectedTransferDate: response === null || response === void 0 || (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.ExpectedTransferDate,
                                            ExpectedDeliveryDate: response === null || response === void 0 || (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.ExpectedDeliveryDate,
                                            ExpectedPickupDate: response === null || response === void 0 || (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.ExpectedPickupDate
                                        }];
                            }
                        });
                    }); },
                    // options: crud[BranchToBranchOutwardKeys.BToBRequisitioList]?.data?.filter((data: ResponseObject) => data?.id),
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceTenantId',
                    label: 'Source branch',
                    required: true,
                    placeholder: 'Select source branch',
                    getListData: getBranchList,
                    apiKey: BranchToBranchOutwardKeys.BToBBranchList,
                    value: (_crud$profilePersonal4 = crud === null || crud === void 0 || (_crud$profilePersonal5 = crud.profilePersonalDetails) === null || _crud$profilePersonal5 === void 0 || (_crud$profilePersonal5 = _crud$profilePersonal5.data) === null || _crud$profilePersonal5 === void 0 ? void 0 : _crud$profilePersonal5.Branches[0].OrganizationId) !== null && _crud$profilePersonal4 !== void 0 ? _crud$profilePersonal4 : null,
                    valueExpr: "id",
                    displayExpr: "Name",
                    disabled: true,
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        var _crud$BranchToBranchO2, _selectedSourceBranch, _selectedSourceBranch2, selectedSourceBranch;
                        return __generator(this, function (_a) {
                            selectedSourceBranch = (_crud$BranchToBranchO2 = crud[BranchToBranchOutwardKeys.BToBBranchList]) === null || _crud$BranchToBranchO2 === void 0 || (_crud$BranchToBranchO2 = _crud$BranchToBranchO2.data) === null || _crud$BranchToBranchO2 === void 0 ? void 0 : _crud$BranchToBranchO2.filter(function (data) { return (data === null || data === void 0 ? void 0 : data.id) === (currValue === null || currValue === void 0 ? void 0 : currValue.id); });
                            return [2 /*return*/, {
                                    SourceParentTenantId: (_selectedSourceBranch = (_selectedSourceBranch2 = selectedSourceBranch[0]) === null || _selectedSourceBranch2 === void 0 ? void 0 : _selectedSourceBranch2.ParentOrganizationId) !== null && _selectedSourceBranch !== void 0 ? _selectedSourceBranch : ''
                                }];
                        });
                    }); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DestinationTenantId',
                    label: 'Destination branch',
                    required: true,
                    placeholder: 'Select destination branch',
                    valueExpr: "id",
                    displayExpr: "Name",
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    setFieldProps: function (formValues, currValue) {
                        var _crud$BranchToBranchO3;
                        return {
                            type: this.type,
                            options: (_crud$BranchToBranchO3 = crud[BranchToBranchOutwardKeys.BToBBranchList]) === null || _crud$BranchToBranchO3 === void 0 || (_crud$BranchToBranchO3 = _crud$BranchToBranchO3.data) === null || _crud$BranchToBranchO3 === void 0 ? void 0 : _crud$BranchToBranchO3.filter(function (data) { return !((data === null || data === void 0 ? void 0 : data.id) === (formValues === null || formValues === void 0 ? void 0 : formValues.SourceTenantId)); })
                        };
                    },
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        var _crud$BranchToBranchO4, _selectedDestinationB, _selectedDestinationB2, selectedDestinationBranch;
                        return __generator(this, function (_a) {
                            selectedDestinationBranch = (_crud$BranchToBranchO4 = crud[BranchToBranchOutwardKeys.BToBBranchList]) === null || _crud$BranchToBranchO4 === void 0 || (_crud$BranchToBranchO4 = _crud$BranchToBranchO4.data) === null || _crud$BranchToBranchO4 === void 0 ? void 0 : _crud$BranchToBranchO4.filter(function (data) { return (data === null || data === void 0 ? void 0 : data.id) === (currValue === null || currValue === void 0 ? void 0 : currValue.id); });
                            return [2 /*return*/, {
                                    DestinationParentTenantId: (_selectedDestinationB = (_selectedDestinationB2 = selectedDestinationBranch[0]) === null || _selectedDestinationB2 === void 0 ? void 0 : _selectedDestinationB2.ParentOrganizationId) !== null && _selectedDestinationB !== void 0 ? _selectedDestinationB : ''
                                }];
                        });
                    }); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Warehouse',
                    required: true,
                    placeholder: 'Select warehouse',
                    getListData: getWarehouseList,
                    valueExpr: "id",
                    displayExpr: "Name",
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    getListData: priorityListGet,
                    setFormState: function (formValues, currValue) {
                        return {
                            Priority: currValue
                        };
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PriorityRemarks',
                    label: "Priority reason (0/150 characters)",
                    placeholder: "Enter Priority reason",
                    maxLength: 150,
                    multiline: true,
                    md: 6,
                    minRows: 2,
                    setFieldProps: function (formValues, value) {
                        var _formValues$Priority, _formValues$Priority2, _value$length;
                        return {
                            type: FormItemTypes.TextInput,
                            containerProps: {
                                display: (formValues === null || formValues === void 0 || (_formValues$Priority = formValues.Priority) === null || _formValues$Priority === void 0 ? void 0 : _formValues$Priority.Name) !== 'High' ? 'none' : 'unset'
                            },
                            required: (formValues === null || formValues === void 0 || (_formValues$Priority2 = formValues.Priority) === null || _formValues$Priority2 === void 0 ? void 0 : _formValues$Priority2.Name) === 'High',
                            label: "Priority reason (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/150 characters)")
                        };
                    }
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'ScheduleTransportDate',
                    label: 'Schedule for transport',
                    disablePast: true,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Logistic details',
            columnSize: 12,
            variant: 'outlined',
            title: 'Logistic details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'TransporterId',
                    label: 'Transporter name',
                    placeholder: 'Select transporter name',
                    required: true,
                    valueExpr: "id",
                    displayExpr: "Name",
                    getListData: getTransporterNameList,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ShippingMethodId',
                    label: 'Shipping method',
                    placeholder: 'Select shipping method',
                    required: true,
                    valueExpr: "id",
                    displayExpr: "Name",
                    getListData: BToBShippingMethodListAPICall,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'ShippingDocumentDate',
                    label: 'Shipping doc date',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    disablePast: true,
                    required: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'ShippingDocumentNo',
                    label: 'Shipping doc number',
                    placeholder: 'Enter shipping doc number',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    validation: ValidationTypes.number
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'VehicleNo',
                    label: 'Vehicle number',
                    placeholder: 'Enter vehicle number',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    validation: ValidationTypes.number
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'PermitNo',
                    label: 'Road permit number',
                    placeholder: 'Enter road permit number',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    validation: ValidationTypes.number
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'BoxQuantity',
                    label: 'No. of boxes',
                    placeholder: 'Enter no. of boxes',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    validation: ValidationTypes.number
                }]
        }];
    var PartDetails = [{
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            labelTypographyProps: {
                display: 'none'
            },
            columnSize: 12,
            element: BToBOutwardPartDetails
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: 'flex-end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'GrandTotal',
                            columnSize: 4,
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                sx: {
                                    flexGrow: 1
                                },
                                fontWeight: "bold",
                                textAlign: "left"
                            }, "Grand Total"),
                            variant: 'outlined',
                            fullWidth: true,
                            sx: {
                                justifyContent: 'space-between',
                                bgcolor: 'rgba(0,0,0,0.05)',
                                fontWeight: 'bold',
                                color: systemColor.secondary
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$StockTran, _formValues$StockTran2, _totalAmt$toFixed;
                                var totalAmt = formValues === null || formValues === void 0 || (_formValues$StockTran = formValues.StockTransferRequisitionDetail) === null || _formValues$StockTran === void 0 ? void 0 : _formValues$StockTran.reduce(function (acc, data) {
                                    return acc + (data.PurchasePrice * data.RequestedQuantity || 0);
                                }, 0);
                                setGrandTotal(totalAmt);
                                var totalQty = formValues === null || formValues === void 0 || (_formValues$StockTran2 = formValues.StockTransferRequisitionDetail) === null || _formValues$StockTran2 === void 0 ? void 0 : _formValues$StockTran2.reduce(function (acc, data) {
                                    return acc + data.RequestedQuantity;
                                }, 0);
                                setTotalQuantity(totalQty);
                                return {
                                    type: this.type,
                                    startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ChevronRightRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null),
                                    endIcon: "\u20B9 ".concat((_totalAmt$toFixed = totalAmt === null || totalAmt === void 0 ? void 0 : totalAmt.toFixed(2)) !== null && _totalAmt$toFixed !== void 0 ? _totalAmt$toFixed : '00.00')
                                };
                            },
                            setFormState: function (formValues, e, field) {
                                return {
                                    Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                                };
                            }
                        }]
                }]
        }];
    var AdditionalInformation = [{
            type: FormItemTypes.CardComponent,
            name: 'AdditionalInfo',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedTransferDate",
                    label: "Expected transfer date",
                    disablePast: true,
                    setFormState: function () {
                        return {
                            ExpectedDeliveryDate: null,
                            ExpectedPickupDate: null
                        };
                    },
                    xs: 6,
                    sm: 6,
                    md: 3
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedPickupDate",
                    label: "Expected pickup date",
                    disablePast: true,
                    setFieldProps: function (formValues) {
                        return {
                            type: FormItemTypes.DatePicker,
                            minDate: dayjs.utc(formValues === null || formValues === void 0 ? void 0 : formValues.ExpectedTransferDate),
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.ExpectedTransferDate)
                        };
                    },
                    setFormState: function () {
                        return {
                            ExpectedDeliveryDate: null
                        };
                    },
                    xs: 6,
                    sm: 6,
                    md: 3
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedDeliveryDate",
                    label: "Expected delivery date",
                    setFieldProps: function (formValues) {
                        return {
                            type: FormItemTypes.DatePicker,
                            minDate: dayjs.utc(formValues === null || formValues === void 0 ? void 0 : formValues.ExpectedPickupDate),
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.ExpectedPickupDate)
                        };
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'TotalTransporterCharges',
                    label: 'Total transporter charges',
                    placeholder: 'Total transporter charges',
                    disabled: true
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 2,
                    marginTop: 0,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'TransferReason',
                            label: 'Transfer reasons (0/200 characters)',
                            placeholder: 'Enter reasons',
                            value: null,
                            md: 6,
                            multiline: true,
                            maxLength: 200,
                            minRows: 2,
                            setFieldProps: function (formValues, value) {
                                var _value$length2;
                                return {
                                    type: this.type,
                                    label: "Transfer reasons (".concat((_value$length2 = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length2 !== void 0 ? _value$length2 : 0, "/200 characters)")
                                };
                            }
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            disabled: false,
                            value: null,
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: BranchToBranchOutwardKeys.StockTransferRequisition
                            },
                            uploadAttachmentAPI: UploadBToBOutwardAttachmentAPICall,
                            deleteAttachmentAPI: DeleteBToBOutwardAttachmentAPICall
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General
        }, {
            id: '1',
            label: 'Part details',
            elements: PartDetails
        }, {
            id: '2',
            label: 'Additional information',
            elements: AdditionalInformation
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            width: '100%',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    flexWrap: 'nowrap',
                    alignItems: "center",
                    justifyContent: "space-between",
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small",
                                onClick: function () {
                                    dispatch(resetState(BranchOutwardApiKeys)), navigate('/branchToBranchOutward');
                                }
                            })
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: mode == 'edit' ? 'Branch to branch outward' : 'Create branch to branch outward',
                            columnSize: true,
                            variant: "h1",
                            noWrap: true
                        }]
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function () { return data !== null && data !== void 0 && data.StatusName ? /*#__PURE__*/ React.createElement(MuiStack, {
                        sx: {
                            border: "1px solid #DEE4EB",
                            borderRadius: "6px",
                            gap: "5px",
                            padding: "3px 8px"
                        },
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement(StatusColor, {
                        status: ''
                    }), /*#__PURE__*/ React.createElement(Typography, {
                        id: "statusKeyId",
                        variant: "h6"
                    }, data === null || data === void 0 ? void 0 : data.StatusName)) : /*#__PURE__*/ React.createElement(React.Fragment, null); }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    xs: 12,
                    sm: true,
                    item: false,
                    justifyContent: {
                        xs: 'space-between',
                        sm: 'flex-end'
                    },
                    spacing: 0,
                    p: {
                        xs: 2,
                        sm: 0
                    },
                    alignItems: 'center',
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentCode',
                            label: 'DOC NO: ',
                            value: null,
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedOn',
                            label: 'DOC DATE: ',
                            value: null,
                            valueGetter: function (formData) {
                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.CreatedOn);
                            },
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Quick Links',
                            disabled: true,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            color: 'primary',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState(BranchOutwardApiKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        formProps: {
            bgcolor: faintblue
        },
        createKey: BranchToBranchOutwardKeys.Create,
        createFormAPI: CreateBToBOutwardAPICall,
        createRequest: {
            TotalQuantity: totalQuantity,
            TotalAmount: grandTotal,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal6 = crud.profilePersonalDetails) === null || _crud$profilePersonal6 === void 0 || (_crud$profilePersonal6 = _crud$profilePersonal6.data) === null || _crud$profilePersonal6 === void 0 ? void 0 : _crud$profilePersonal6.IdentityId,
            DestinationParentTenantId: UserParentOrganization !== null && UserParentOrganization !== void 0 ? UserParentOrganization : '',
            SourceParentTenantId: UserParentOrganization !== null && UserParentOrganization !== void 0 ? UserParentOrganization : '',
            DocumentDate: new Date().toISOString(),
            Status: "Draft",
            Type: "BToBOutward"
        },
        onClose: function () {
            dispatch(showNewNotification({
                isOpen: true,
                title: 'Success',
                message: 'Save Successfully',
                type: 'success'
            }));
            navigate(-1);
        }
    }));
}
export default CreateBranchToBranchOutward;
